import {toast} from "react-toastify";
import {cloneDeep, uniqBy} from "lodash";
import {assertArray} from "core/validation";
export const REPORT_TYPE = {
    ADV:"ADV",
    LOG:"LOG"
};

export function deleteFromState (adv, state) {
    const index = state.advertisers.findIndex(a => a.id === adv.id);
    const indexToReport = state.advToReport.findIndex(a => a.id === adv.id);
    const advertisers = index!== -1 ? state.advertisers.filter((_,i) => index !== i): state.advertisers;
    const advToReport = indexToReport !== -1 ? state.advToReport.filter((_, i) => i !== indexToReport): state.advToReport;
    const advertisementTypes = advertisers.map(a => (
        {...a.advertisementType, value: a.advertisementType.id, label: a.advertisementType.name}));
    return {
        advertisers,
        advToReport,
        advertisersCount: advertisers.length,
        advertisementTypes:uniqBy(advertisementTypes, (e) => e.id),
    };
}

export function advertiserFailedAdvRepited(){
    const messages = "The advertisement has already been added to the report";
    toast.warn(messages, {
        position:"bottom-right"
    });
}
export function advertiserAddedSuccess(advertisersCount, reportName){
    const messages = `${advertisersCount} advertisements added to ${reportName}`;
    toast.info(messages, {
        position:"bottom-right"
    });
}

export function filterUpAdv(advs, stateAdvertisers){
    const selectedAdvs = assertArray(stateAdvertisers) ? cloneDeep(stateAdvertisers): [];
    if(assertArray(selectedAdvs)) {
        return advs.filter(ad => {
            return selectedAdvs.findIndex(a => a.id === ad.id) === -1;
        });
    }
    return advs;

}
